import React from 'react';

const Details = () => {
    return (
        <div className='grid grid-cols-2 gap-4 m-4'>
            <div className="card w-96 bg-base-100 shadow-xl divide-orange-400">
                <div className="card-body divide-orange-400">
                    <h2 className="card-title text-[#F7941D] uppercase">December Month</h2>
                    <hr className="h-px my-2 bg-[#F7941D]"></hr>
                    <div className='font-medium'>
                        <p>Donar<span className='ml-[200px]'>: BDT 0.00</span></p>
                        <p>Donate<span className='ml-48'>: BDT 0.00</span></p>
                        <p>Volunteer Commission<span className='ml-[81px]'>: BDT 0.00</span></p>
                        <p>Volunteer Withdraw</p>
                    </div>
                </div>
            </div>
            <div className="card w-96 bg-base-100 shadow-xl divide-orange-400">
                <div className="card-body divide-orange-400">
                    <h2 className="card-title text-[#F7941D] uppercase">Total</h2>
                    <hr className="h-px my-2 bg-[#F7941D]"></hr>
                    <div className='font-medium'>
                        <p>Donar<span className='ml-[200px]'>: BDT 0.00</span></p>
                        <p>Donate<span className='ml-48'>: BDT 0.00</span></p>
                        <p>Volunteer Commission<span className='ml-[81px]'>: BDT 0.00</span></p>
                        <p>Volunteer Withdraw</p>
                    </div>
                </div>
            </div>
            <div className="card w-96 bg-base-100 shadow-xl divide-orange-400 mt-2">
                <div className="card-body divide-orange-400">
                    <h2 className="card-title text-[#F7941D] uppercase">Donation Type Wise (December)</h2>
                    <hr className="h-px my-2 bg-[#F7941D]"></hr>
                    <div className='font-medium'>
                        <p className=''>One Time Donation <span className='ml-[100px]'>: BDT 0.00</span></p>
                        <p>Donate for flood victims <span className='ml-[66px]'>: BDT 0.00</span></p>
                        <p>Food For All<span className='ml-[159px]'>: BDT 0.00</span></p>
                        <p>Zakat for Education <span className='ml-[100px]'>: BDT 0.00</span></p>
                        <p>Donation for Street Hawker <span className='ml-[43px]'>: BDT 0.00</span></p>
                        <p>Palestine Medical Equipment Aid <span className='ml-1'>: BDT 0.00</span></p>
                        <p>Palestine Medicine Aid<span className='ml-[82px]'>: BDT 0.00</span></p>
                        <p>Eid Gift<span className='ml-[193px]'>: BDT 0.00</span></p>
                        <p>প্রজেক্ট নিজ পায়ে দাঁড়াই<span className='ml-[81px]'>: BDT 0.00</span></p>
                    </div>
                </div>
            </div>
            <div className="card w-96 bg-base-100 shadow-xl divide-orange-400 mt-2">
                <div className="card-body divide-orange-400">
                    <h2 className="card-title  text-[#F7941D] uppercase">Donation Type Wise (Total)</h2>
                    <hr className="h-px my-2 bg-[#F7941D]"></hr>
                    <div className='font-medium'>
                        <p className=''>One Time Donation <span className='ml-[100px]'>: BDT 0.00</span></p>
                        <p>Donate for flood victims <span className='ml-[66px]'>: BDT 0.00</span></p>
                        <p>Food For All<span className='ml-[159px]'>: BDT 0.00</span></p>
                        <p>Zakat for Education <span className='ml-[100px]'>: BDT 0.00</span></p>
                        <p>Donation for Street Hawker <span className='ml-[43px]'>: BDT 0.00</span></p>
                        <p>Palestine Medical Equipment Aid <span className='ml-1'>: BDT 0.00</span></p>
                        <p>Palestine Medicine Aid<span className='ml-[82px]'>: BDT 0.00</span></p>
                        <p>Eid Gift<span className='ml-[193px]'>: BDT 0.00</span></p>
                        <p>প্রজেক্ট নিজ পায়ে দাঁড়াই<span className='ml-[81px]'>: BDT 0.00</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Details;